export default "__VITE_ASSET__38af826a__"